import { Controller } from '@hotwired/stimulus'

export default class KycFileFeedbackController extends Controller {
  static targets = ['name', 'input', 'placeholder', 'container'];

  connect() {
    if (this.inputTarget.files[0]) this.showFileNameAndFilledIcon();
  }

  showFileNameAndFilledIcon(_event) {
    this.placeholderTarget.classList.add('d-none');
    this.nameTarget.textContent = this.inputTarget.files[0].name;
    this.nameTarget.classList.add('mb-1');
    this.containerTarget.classList.remove('border-gray-200');
    this.containerTarget.classList.add('border-primary');
  }
}
